import {
	EBoxStructureType,
	TBoxStructure,
} from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { ETableStructureType } from 'ui/EasTable/types';

export const boxStructure: TBoxStructure<{
	vat_amount_reported: number;
	vat_amount_to_be_reported: number;
	total: number;
}> = {
	body: [
		{
			name: 'VAT Amount Reported',
			selector: 'vat_amount_reported',
			type: ETableStructureType.AMOUNT,
			editable: false,
		},
		{
			name: 'VAT amount to be reported',
			selector: 'vat_amount_to_be_reported',
			type: ETableStructureType.AMOUNT,
			editable: false,
		},
		{
			name: 'Total reports',
			selector: 'total',
			type: ETableStructureType.NUMBER,
			editable: false,
		},
	],
	header: [],
	title: 'Fiscal Reports',
};
